import { render } from "./AMLTrainingDownload.vue?vue&type=template&id=47408742&scoped=true"
import script from "./AMLTrainingDownload.vue?vue&type=script&lang=js"
export * from "./AMLTrainingDownload.vue?vue&type=script&lang=js"

import "./AMLTrainingDownload.vue?vue&type=style&index=0&id=47408742&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47408742"]])

export default __exports__